module.exports = __webpack_public_path__ + "static/specter-053f33f0ffe6d7232d98bb2393aa6795.jpeg";